/**
 * The buying guide for a listing's model, if the site has one.
 *
 * Shared by pages/buyer/VehicleDetail.js and scripts/inject-seo-heads.js so a
 * crawler and a visitor get the same link. Import-free: the injector loads it
 * by stripping `export` and requiring it.
 *
 * Why: an internal-link audit of the live site (2026-09-28) found the model
 * guides for cars BST actually stocks — Xcent, Camry, Amaze, Hycross — had
 * one or two contextual links from anywhere, while the listings of exactly
 * those cars linked to none of them. A guide next to the car it describes is
 * the most relevant link either page can get, and it gives a buyer the "what
 * should I check / what is it worth" answer at the moment they are deciding.
 *
 * Order matters — first match wins, most specific first ("innova crysta" and
 * "hycross" before plain "innova"). The four model hubs outrank blog guides:
 * they are the commercial pages for those models.
 */
export const MODEL_GUIDES = [
  [/innova\s*crysta/, '/innova-crysta-commercial-taxi-delhi', 'Innova Crysta'],
  [/hycross/, '/blog/buy-innova-hycross-taxi-india', 'Innova Hycross'],
  [/innova/, '/blog/buy-innova-for-taxi-india', 'Innova'],
  [/fortuner/, '/fortuner-commercial-taxi-delhi', 'Fortuner'],
  [/ertiga/, '/ertiga-commercial-taxi-delhi', 'Ertiga'],
  [/d[ez]{1,2}ire/, '/dzire-commercial-taxi-delhi', 'Dzire'],
  [/xcent/, '/blog/used-xcent-taxi-for-sale-india', 'Xcent'],
  [/camry/, '/blog/used-camry-taxi-for-sale-india', 'Camry'],
  [/amaze/, '/blog/buy-honda-amaze-taxi-india', 'Honda Amaze'],
  [/wag[a-z]*\s*-?\s*r\b|wagnor/, '/blog/used-wagonr-taxi-for-sale-india', 'WagonR'],
  [/rumi(y?o)n/, '/blog/used-rumion-taxi-for-sale-india', 'Rumion'],
  [/\baura\b/, '/blog/used-aura-taxi-for-sale-india', 'Aura'],
  [/eeco/, '/blog/used-maruti-eeco-taxi-delhi', 'Eeco'],
];

export function modelGuideFor(v) {
  const text = `${(v && v.brand) || ''} ${(v && v.model) || ''}`.toLowerCase();
  for (const [re, path, name] of MODEL_GUIDES) {
    if (re.test(text)) return { path, name, label: `${name} taxi buying guide` };
  }
  return null;
}
